import { Enums } from '@/lib/types/supabase';

export const ORDER_STATUS_LABELS: {
  [key in Enums<'order_status_enum'>]: string;
} = {
  new: 'Nouveau',
  'in-progress': 'En cours',
  delivered: 'Livrée',
  closed: 'Clôturée',
  rejected: 'Rejetée',
  cancelled: 'Annulée',
};

export const ORDER_STATUS_VALUES: Enums<'order_status_enum'>[] = [
  'new',
  'in-progress',
  'delivered',
  'closed',
  'rejected',
  'cancelled',
];

export const ppOrderStatus = (status?: Enums<'order_status_enum'> | null) => {
  if (!status) {
    return '';
  }

  if (status in ORDER_STATUS_LABELS) {
    return ORDER_STATUS_LABELS[status];
  }

  return status;
};
